module.exports = function() {
  return new Worker(__webpack_public_path__ + "2d644e84534ee6364dea.worker.js");
};